module.exports = __webpack_public_path__ + "static/Muli-LightItalic.c2af589e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-LightItalic.ttf
// module id = 338
// module chunks = 114276838955818